<template>
  <div style="transform: translateY(-1px);">
    <div class="kfbox">
      <div class="flex-between ph20">
        <span class="icon18a pl40 col4d f14 lh25">微信 8440824</span>
        <button type="button" data-clipboard-text="8440824" @click="copy" class="btncopy flex-column align-center">复制
        </button>
      </div><!---->
      <div class="flex-between pl20 pr20 pt15 pb15">
        <span class="icon18a pl40 col4d f14 lh25">微信 8133835</span>
        <button type="button" data-clipboard-text="8133835" @click="copy" class="btncopy flex-column align-center">复制
        </button>
      </div><!---->
      <div class="flex-between pl20 pr20 pb10">
        <span class="icon18a pl40 col4d f14 lh25">微信 4901090</span>
        <button type="button" data-clipboard-text="4901090" @click="copy" class="btncopy flex-column align-center">复制
        </button>
      </div><!---->
      <div class="f14 lh22" style="color: #4d4d4d;">vip心易售后电话：<a href="tel:18989545463" style="color: #4d4d4d;">18989545463</a> </div>
      <div class="flex-between align-center pt5">
        <span class="f14 lh22">vip心易投诉微信：miyazhu777</span><button type="button" data-clipboard-text="miyazhu777" @click="copy" class="btncopy flex-column align-center">复制
        </button>
      </div>


      <div class="f13 lh22 pv10" style="color: #4d4d4d;"><b>主要负责：</b>弥亚猪平台的售前服务 成交换绑 售后服务 约定中介交易 业务介绍 业务分流
        有任何不清楚的问题都可以咨询综合客服
      </div>
      <div class="f13 lh22" style="color: #4d4d4d;"><b>客服服务时间：</b>凌晨0:00-24:00 24小时在线 客服轮班上岗 全年无休 欢迎咨询 用餐时间回复会稍微延迟 敬请理解
        中餐11点 晚餐17点 夜宵22点
      </div>

      <div class="flex-center align-center pt10"><span class="kfgb flex-column align-center f14">关闭</span></div>

      <!-- <div class="flex-center pt10 pb15"><a href="https://url.cn/5phi9rb?_type=wpa&amp;qidian=true" target="_blank" class="icon18b flex-column align-center" style="opacity: 0;height: 0;overflow: hidden;"><span>在线客服（不推荐）</span></a></div> -->
      <!-- <div class="kftxt">梦幻西游手游客户推荐微信客服<br/>微信客服对梦幻更专业建议联系微信客服</div>
      <div class="p10 col4d f14 lh22 tc">vip售后电话18989545463<br/>vip心易售后微信:miyazhu266<br/> (心易售后是最高级服务微信老板们对于提供建议服务不满意客服服务以及需要提供特殊服务待遇等都可以让心易售后处理)<br/>www.miyazhu.com</div> -->
      <!-- <div class="flex-center align-center">
        <span class="flex-column align-center" style="background: #eeeeee;color:#989898; border-radius: 4px;width: 70px;height: 32px;font-size: 15px;    box-shadow: 0 0 0.07rem rgba(0, 0, 0, 0.2);">关闭</span>
      </div> -->
    </div><!--kfbox end-->


  </div>
</template>

<script>
import Clipboard from 'clipboard'

export default {
  components: {},
  name:       'kf',

  methods: {
    copy() {

      let clipboard = new Clipboard('.btncopy')
      clipboard.on('success', e => {
        this.mui.toast('复制成功')
      })
      clipboard.on('error', e => {
        //console.log('该浏览器不支持复制')
      })


    },
  },
}
</script>

